import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { handleRedirectCallback } from "../auth/oidc";

export function OAuthCallback(): JSX.Element {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    void handleRedirectCallback()
      .then(() => {
        if (active) {
          navigate("/", { replace: true });
        }
      })
      .catch((err: unknown) => {
        if (active) {
          setError(err instanceof Error ? err.message : String(err));
        }
      });
    return () => {
      active = false;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="auth-shell">
        <div className="auth-card">
          <div className="auth-card__brand">⚠️</div>
          <h1 style={{ marginBottom: 6 }}>Error de autenticación</h1>
          <p className="text-muted">{error}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-card__brand">💧</div>
        <p className="text-muted">Completando inicio de sesión…</p>
      </div>
    </div>
  );
}
